import apiClient from './apiClient.js';

const quoterService = {
    getAllQuoter(){
       return apiClient.get('/cotizacion/'); 
    },
    getQuoterById(id){
    return apiClient.get(`/cotizacion/${id}/`);
    },
    updateQuoter(id, data){
        return apiClient.patch(`/cotizacion/${id}/`, data);
    },
    createQuoter(data){
        return apiClient.post('/cotizacion/', data);
    },
    deleteQuoter(id){
        return apiClient.delete(`/cotizacion/${id}/`);
    },
    getProyectosPorCliente(id_cliente) {
    return apiClient.get(`/cotizacion/?cliente=${id_cliente}`);
  },
}



export default quoterService;